import React from "react"
import '../lib/index.css'
import { useNavigate } from 'react-router-dom';
import { MenuPageSelect } from "../../../shared/lib/types/Types";

interface DDselectPageProp {
    updatePageName: Function,
    arrayPages: MenuPageSelect[],
    arrayLink: string[],
    currentLocation: string
}

export const DDselectPage = ({updatePageName, arrayPages, arrayLink, currentLocation}: DDselectPageProp) => {
    const updateInfo = (value: MenuPageSelect, index: number) => {
        updatePageName({
            pageName: value.title,
            index: index
        })
    }
    const navigate = useNavigate();

    return (
        <div className="selectPage-container">
            <ul className="selectPage-list">
                {
                    arrayPages.map((item, index) => (
                        <li key={index} 
                            className={currentLocation === arrayLink[index] ? 
                                "selectPage-item selected-item" : "selectPage-item"} 
                            onTouchEnd={() => updateInfo(item, index)}>
                            <div
                            onClick={() => navigate(`${arrayLink[index]}`)} 
                                className='selectPage-link' >
                                <span key={index} 
                                    className="selectPage-svg">
                                        {arrayPages[index].img}
                                </span>
                                {item.title}
                            </div>
                           
                        </li>
                    ))
                }
            </ul>
        </div>
    )
}
 